import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"
import Home from "../pages/Home";
import User from "../pages/User";
import Login from "../pages/Login";
import App from "../app";
import Wechat from "../pages/Wechat";
import BindMobile from "../pages/Wechat/BindMobile";
import Order from "../pages/Order";
import PayOrder from "../pages/Order/PayOrder";
import PayOrderResult from "../pages/Order/PayOrder/PayOrderResult";
import Scan from "../pages/Scan";
import Wallet from "../pages/Wallet";
import IcCard from "../pages/IcCard";
import IllegalRecord from "../pages/IllegalRecord";
import CardBind from "../pages/IcCard/CardBind";
import PowerList from "../pages/Order/PowerList";
import Report from "../pages/Report";
import Alipay from "../pages/Alipay";
import AlipayBindMobile from "../pages/Alipay/BindMobile";

const AppRouter = () => {
  return (
    <Router>
      <App />
      <Routes>
        <Route path="/" element={<Navigate to="/home" />}></Route>
        <Route exact path="/home" element={<Home />} ></Route>
        <Route path="/user" element={<User />} ></Route>
        <Route path="/order" element={<Order />} ></Route>
        <Route path="/order/:orderId/pay" element={<PayOrder />} ></Route>
        <Route path="/order/:orderId/power/list" element={<PowerList />} ></Route>
        <Route path="/order/pay/result/:orderResult" element={<PayOrderResult />} ></Route>
        <Route path="/scan" element={<Scan />} ></Route>
        <Route path="/login" element={<Login />} ></Route>
        <Route path="/login/wechat" element={<Wechat />} ></Route>
        <Route path="/login/wechat/bind/mobile" element={<BindMobile />} ></Route>
        <Route path="/login/alipay" element={<Alipay />} ></Route>
        <Route path="/login/alipay/bind/mobile" element={<AlipayBindMobile />} ></Route>
        <Route path="/wallet/:walletId" element={<Wallet />} ></Route>
        <Route path="/card/list" element={<IcCard />} ></Route>
        <Route path="/card/bind" element={<CardBind />} ></Route>
        <Route path="/illegal" element={<IllegalRecord />} ></Route>
        <Route path="/report" element={<Report />} ></Route>
      </Routes>
    </Router>
  )
}

export default AppRouter;